export default {
    methods: {
        makeToast(
            title,
            message,
            variant = "success",
            toaster = "b-toaster-top-right"
        ) {
            this.$bvToast.toast(message, {
                title: title,
                autoHideDelay: 5000,
                appendToast: true,
                solid: true,
                toaster: toaster,
                variant: variant
            });
        },
        showError(
            title,
            message,
            variant = "danger",
            toaster = "b-toaster-top-right"
        ) {
            this.$bvToast.toast(message, {
                title: title,
                autoHideDelay: 5000,
                appendToast: true,
                solid: true,
                toaster: toaster,
                variant: variant
            });
        }
    }
};
